module.exports = __webpack_public_path__ + "img/list_Character_sq_11.ba12eaca.jpeg";